import { module } from 'modujs';

import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                closeInfowindow: 'closeInfowindow',
            },
        }

        this.currentInfowindow = false;
        this.map = false;
        // this.MarkerClusterer = null;
        // this.oms = null;
        // const svg = window.btoa(`
        //         <svg fill="#7DD1CA" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        //         <circle cx="120" cy="120" opacity="1" r="70" />
        //         <circle cx="120" cy="120" opacity=".7" r="90" />
        //         <circle cx="120" cy="120" opacity=".3" r="110" />
        //         <circle cx="120" cy="120" opacity=".2" r="130" />
        //         </svg>`);
        // this.MarkerClustererOptions = {
        //     render: ({ count, position }) =>

        //       new google.maps.Marker({
        //         label: { text: String(count), color: "#001c4a", fontSize: "12px", fontWeight: "400" },
        //         icon: {
        //             url: `data:image/svg+xml;base64,${svg}`,
        //             scaledSize: new google.maps.Size(40, 40),
        //           },
        //         position,
        //         // adjust zIndex to be above other markers
        //         zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        //       })
        // };
    }

    init() {
        if(this.getData('apikey')) {
            const $this = this;
            
            const loader = new Loader({
                apiKey: $this.getData('apikey'),
                version: "weekly",
              });
    
            const el = this.$('map');
            // var map = false;
            setTimeout(() => {
                loader.load().then(() => {
                    this.map = this.initMap($(el))
                });
                // if (google !== undefined) {
                    // this.map = this.initMap($(el))
                // }
            }, 2000);
            document.addEventListener("googlemaps_loaded", function() {
                setTimeout(() => {
                    // if (google !== undefined && this.map === false) {
                    //   this.map = this.initMap($(el));
                    // }
                    loader.load().then(() => {
                        this.map = this.initMap($(el))
                    });
                }, 2000);
            });
        }else {
            console.log('Need Google Maps ApiKey');
        }
    }

    closeInfowindow(e) {
        let el = this.el;
        $(el).find('.c-map_infowindow').removeClass('is-open');
        // this.currentInfowindow.close();
    }

    updateMap(categories) {
        let markers = this.map.markers;
        
        markers.forEach(marker => {
            if(categories.length) {
                if(categories.indexOf(marker.id) != -1) {
                    marker.setVisible(true);
                }
                else {          
                    marker.setVisible(false);
                }
            }else{
                marker.setVisible(false);
            }
        })

        this.MarkerClusterer.setMap(null);
        let map = this.map;
        const renderer = this.MarkerClustererOptions;
        // this.MarkerClusterer = new MarkerClusterer({ markers, map, renderer });

        this.centerMap(this.map);
    }

    initMap( $el ) {
        $('.c-map_wrap').removeClass('is-hidden');
        let t = this;
        
        // Find marker elements within map.
        var $markers = $el.find('.marker');
    
        var styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#001C4A"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#E6F5FA"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#7DD1CA"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#7DB2E0"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#001C4A"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#BCDFED"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46BCEC"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#B9DCFA"
                    }
                ]
            }
        ];
    
        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            styles: styles,
            maxZoom: 15,
            fullscreenControl: false,
            // disableDefaultUI: true,
            streetViewControl: false,
            mapTypeControl: false,
        };
        var map = new google.maps.Map( $el[0], mapArgs );       
    
        // Add markers.
        map.markers = [];
        $markers.each(function(){
            t.initMarker( $(this), map );
        });
    
        // Center map based on markers.
        t.centerMap( map );
    
        // Return map instance.
        return map;
    }

    initMarker( $marker, map ) {
        let t = this;
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };
    
        var icon = null;
        if($marker.data('icon')) {
            icon = {
                url : $marker.data('icon'),
                scaledSize: new google.maps.Size(30, 30)
            };
        }
    
        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            id: $marker.data('id'),
            icon: icon
        });
    
        // Append to reference for later use.
        map.markers.push( marker );
    
        // If marker contains HTML, add it to an infoWindow.
        // if( $marker.html() ){
        //     // Create info window.
        //     var infowindow = new google.maps.InfoWindow({
        //         content: $marker.html()
        //     });
    
        //     // Show info window when marker is clicked.
        //     google.maps.event.addListener(marker, 'click', function() {

        //         if( t.currentInfowindow ) {
        //             t.currentInfowindow.close();
        //         }
        //         infowindow.open( map, marker );
        //         t.currentInfowindow = infowindow;
        //         map.panTo(marker.getPosition());
        //         // t.openPopup(marker);
        //     });
        // }

        google.maps.event.addListener(marker, 'click', function() {
            t.openPopup(marker);
        });
    }

    openPopup(marker){
        let el = this.el;
        let markers = this.map.markers;
        let pos = marker.getPosition();
        let ids = [];

        for (let j = 0; j < markers.length; j++) {
            if (pos.equals(markers[j].getPosition())) {
                ids.push(markers[j].id);
            }
        }
    
        $.ajax({
            url: '/wp/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {action: 'map_infowindow', ids: ids},
            success: function( response ){
                $(el).find('.c-map_infowindow_posts').html(response.content);
                $(el).find('.c-map_infowindow').addClass('is-open');
                // setTimeout(() => {
                //     t.call('update', false, 'Scroll'); // update Locomotive Scroll
                // }, 1000);
            },
        });
    }

    centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });
    
        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
    
        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }
}
